import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { ClientRes } from 'api/swagger/index.ts';
import { useTransformToTableData } from 'shared/hooks/use-transform-to-table-data.ts';
import { findCountriesById } from 'shared/utils/countries';
import type { ClientType } from 'types/client.ts';
import { ClientFactoringTag } from 'components/clients/client-factoring-tag';
import { ClientFinancialTag } from 'components/clients/client-financial-tag';
import { ClientTypeTag } from 'components/clients/client-type-tag';
import { useGetCountries } from '../../../api/countries/use-get-countries.ts';
import type { IClientTablesProps } from './types.ts';

export const ClientTable: React.FC<IClientTablesProps> = (props) => {
  const { clients, isLoading } = props;

  const tableData = useTransformToTableData(clients);

  const { data: countries } = useGetCountries();

  const columns: ColumnsType<ClientRes> = [
    {
      title: 'Name',
      dataIndex: 'name',
      width: '30%',
      render: (name: string, { id }) => <Link to={`/clients/${id}`}>{name}</Link>,
    },
    {
      title: 'Vat number',
      dataIndex: 'vatNumber',
      render: (vatNumber: string) => vatNumber,
    },
    {
      title: 'Type',
      key: 'type',
      dataIndex: 'type',
      render: (type: ClientType, client) => <ClientTypeTag type={type} isVip={client.isVip} />,
    },
    {
      title: 'Payment info',
      dataIndex: 'payment_info',
      render: (_, { paymentTerms, paymentPeriod, factoringEnabled }) => {
        return (
          <Flex align='center' gap='small' wrap>
            <ClientFinancialTag clientPaymentPeriod={paymentPeriod} clientPaymentTerms={paymentTerms} />
            {factoringEnabled ? <ClientFactoringTag /> : null}
          </Flex>
        );
      },
    },
    {
      title: 'Country',
      dataIndex: 'legalCountryId',
      render: (legalCountryId) => {
        const country = findCountriesById(legalCountryId, countries);

        return country?.name;
      },
    },
  ];

  return (
    <div>
      <Table
        size={'small'}
        columns={columns}
        dataSource={tableData}
        pagination={false}
        loading={isLoading ? { size: 'large', delay: 200 } : false}
        bordered
      />
    </div>
  );
};
